module.exports = __webpack_public_path__ + "img/resources-article-classical-pilates@2x.ad01fe0c.jpg";